import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import ClassRoomDetails from "ClassRoom/routes/ClassRoomDetails";
export default store => ({
  path: "class-stream-manager",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "classRoom-todos" */ "./components"),
        import(
          /* webpackChunkName: "classRoom-todos" */ "ClassRoom/modules/ClassRoomModule"
        ),
        import(
          /* webpackChunkName: "classRoom-todos" */ "Post/modules/PostModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        const post = importedModule2.default;
        injectReducer(store, {
          key: "classRoom",
          reducer,
        });
        injectReducer(store, {
          key: "post",
          reducer: post,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ClassRoomDetails(store)],
});
